/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  ContractAddress,
  ContractAddressBinance,
  ContractAddressGoerli,
  ContractAddressRinkeby,
} from '@mogul/shared';
import {
  ChainId,
  Pair,
  Route,
  Token,
  TokenAmount,
  Trade,
  TradeType,
  WETH,
} from '@uniswap/sdk';
import { parseEther } from 'ethers/lib/utils';
import React, { createContext } from 'react';

import type { walletClientToSigner } from '../../../lib';

const chainId = ChainId.MAINNET;
export const STARS = new Token(
  chainId,
  ContractAddress.Stars,
  18,
  'MOGUL',
  'Mogul Stars',
);
const chainIdRinkeby = ChainId.RINKEBY;
export const STARSRINKEBY = new Token(
  chainIdRinkeby,
  ContractAddressRinkeby.Stars,
  18,
  'MOGUL',
  'Mogul Stars',
);
const chainIdGoerli = ChainId.GÖRLI;
export const STARSGOERLI = new Token(
  chainIdGoerli,
  ContractAddressGoerli.Stars,
  18,
  'MOGUL',
  'Mogul Stars',
);
export const defaultPair = new Pair(
  new TokenAmount(STARS, parseEther('1').toString()),
  new TokenAmount(WETH[STARS.chainId], parseEther('1').toString()),
);
export const defaultRoute = new Route([defaultPair], WETH[STARS.chainId]);
export const defaultTrade = new Trade(
  defaultRoute,
  new TokenAmount(WETH[STARS.chainId], parseEther('1').toString()),
  TradeType.EXACT_INPUT,
);

export const STARSBINANCE = new Token(
  56 as ChainId,
  ContractAddressBinance.Stars,
  18,
  'MOGUL',
  'Mogul Stars',
);
export const WBNB = new Token(
  56 as ChainId,
  '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
  18,
  'WBNB',
  'Wrapped BNB',
);
export const BUSDT = new Token(
  56 as ChainId,
  '0x55d398326f99059fF775485246999027B3197955',
  18,
  'USDT',
  'Binance USDT',
);

export const defaultPairBinance = new Pair(
  new TokenAmount(STARSBINANCE, parseEther('1').toString()),
  new TokenAmount(BUSDT, parseEther('100').toString()),
);
export const defaultRouteBinance = new Route([defaultPairBinance], BUSDT);
export const defaultTradeBinance = new Trade(
  defaultRouteBinance,
  new TokenAmount(BUSDT, parseEther('100').toString()),
  TradeType.EXACT_INPUT,
);

export interface TradeStateContextType {
  initialized: boolean;
  value: string;
  pair: Pair;
  trade: Trade;
  setValue: (ethValue: string) => void;
  updateTrade: (newEthValue: string) => void;
  executeTrade: (
    signer: ReturnType<typeof walletClientToSigner>,
    recipient: string,
    slippageTolerance: string,
  ) => Promise<string>;
}

export const TradeStateContext = createContext({} as TradeStateContextType);
